"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var splitByIndex = function splitByIndex(value, index) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "space";
  var formatString = format === "space" ? " " : "-";
  if (value.length < index) return value;
  return [value.substring(0, index)].concat(splitByIndex(value.substring(index), index, format)).filter(function (chunk) {
    return chunk;
  }).join(formatString);
};

exports.default = splitByIndex;